<template>
  <div id="app">
    <HeaderComponent />
    <HeroComponent />
    <BrandsComponent />
    <AppFeatureComponent />
    <JackpotComponent />
    <DesignComponent />
    <ReasonComponent />
    <FAQComponent />
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from "./Home/HeaderComponent";
import HeroComponent from "./Home/HeroComponent";
import BrandsComponent from "./Home/TrustedCompaniesComponent";
import AppFeatureComponent from "./Home/AppFeatureComponent";
import JackpotComponent from "./Home/JackpotComponent";
import DesignComponent from "./Home/DesignComponent";
import ReasonComponent from "./Home/ReasonComponent";
import FAQComponent from "./Home/FAQComponent";
import FooterComponent from "./Home/FooterComponent";
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init({
  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 100, // offset (in px) from the original trigger point
  delay: 200, // values from 0  to 3000, with step 50ms
  duration: 800, // values from 0 to 3000, with step 50ms
  anchorPlacement: "top-bottom" // defines which position of the element regarding to window should trigger the animation
});

export default {
  name: "App",
  components: {
    HeaderComponent,
    HeroComponent,
    BrandsComponent,
    AppFeatureComponent,
    JackpotComponent,
    DesignComponent,
    ReasonComponent,
    FAQComponent,
    FooterComponent
  },
  methods:{},
  created: function(){
  }

};
</script>
<style>
@import url("../assets/style/style.css");
</style>
